import React, { useState, useRef, useEffect } from 'react';
import { styled } from 'styled-components';
import { Button, FlexBoxHorizontal, FlexBoxVertical, FlexItem, FlexBox, Label, TranslateTypography, TextField } from '../../atoms';
import { LuImagePlus } from 'react-icons/lu';
import i18n from '../../../utils/i18n'
import { translateText } from '../../../utils/translateText';
import { useTranslation } from 'react-i18next';

export const PrdtDescriptionTab = ({ data }) => {
      const { t } = useTranslation();
      const language = i18n.language;
      const [imgSrc, setImgSrc] = useState({});
      const [imageError, setImageError] = useState({}); // 추가
      const imgRef = useRef(null);
      const textareaRef = useRef(null); // textarea용 ref 추가
      const [isLoading, setIsLoading] = useState(false);
      const [snowflakeData, setSnowflakeData] = useState([]);
      const [isEditMode, setIsEditMode] = useState(false); // 편집 모드 상태
      const [description, setDescription] = useState(''); // 설명 입력 필드 상태
      // 저장 및 번역 설정 상태
      const [isSaving, setIsSaving] = useState(false);
      const [includeTranslation, setIncludeTranslation] = useState(false); // 기본값: 체크됨
      const [imageEditMode, setImageEditMode] = useState(false);
      
      // 새로 추가할 상태 변수들
      const [activeTab, setActiveTab] = useState('ko'); // 현재 활성 탭 (ko, en, cn)
      const [descriptions, setDescriptions] = useState({
        ko: '',
        en: '',
        cn: ''
      }); // 각 언어별 설명

      useEffect(() => {
        if (!data) return;
        setIsLoading(true);
        // 데이터가 새로 들어올 때마다 편집 모드 초기화
        setIsEditMode(false);
        setDescription('');
        setIncludeTranslation(true); // 편집 모드 진입 시 항상 체크된 상태로 초기화
        setImageError(false); // 이미지 에러 상태 초기화
        setImgSrc(`https://static-dashff.fnf.co.kr/interstellar/prdt_description/${data.brd_cd}/${data.gtm_sesn}/${data.part_cd}.jpg?timestamp=${new Date().getTime()}`);
        
        // 페이지 로드 시 Snowflake 데이터 가져오기
        fetch('/api/cad-data/get-prdt-description', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ brd_cd: data.brd_cd, sesn: data.gtm_sesn, part_cd: data.part_cd })  
        })
          .then(response => response.json())
          .then(data => {
            console.log(data)
            setSnowflakeData(data)
            
      })
    }, [data]); // data 변경 감지

    useEffect(() => {
      setIsEditMode(false);
    }, [language])

      const handleFileChange = async (event) => {
        const file = event.target.files[0];
        if (file) {
          // 편집모드가 아닐 때 업로드 차단
          // 파일이 선택되면 자동으로 업로드
          await handleUpload(file);
        }
      };
    
    
      const handleUpload = async (file) => {
        if (!data) {
          alert('이미지를 업로드할 품번/컬러를 선택하세요.');
          return;
        }
        const formData = new FormData();
    
        // 원본 파일 추가
        formData.append('originalFile', file);
    
        // 메타데이터 추가
        formData.append('part_cd', data['part_cd']);
        formData.append('sesn', data['gtm_sesn']);
        formData.append('brd_cd', data['brd_cd']);
      
        try {
          const response = await fetch('/api/prdt-description-upload', {
            method: 'POST',
            body: formData,
          });
          const result = await response.text();
          alert(result);
      
          // 업로드 성공 시 이미지 초기화
          handleDeleteImage();

          setImgSrc(`https://static-dashff.fnf.co.kr/interstellar/prdt_description/${data.brd_cd}/${data.gtm_sesn}/${data['part_cd']}.jpg?timestamp=${new Date().getTime()}`);
          setImageError(false);
          setImageEditMode(false);
    
        } catch (error) {
          console.error('업로드 오류:', error);
          alert('파일 업로드에 실패했습니다.');
        }
      };
    
      const fileInputRef = React.useRef();
    
      // 이미지 삭제 핸들러
      const handleDeleteImage = () => {
        // 파일 입력 필드 값 초기화
        if (fileInputRef.current) {
          fileInputRef.current.value = ''; // 동일한 파일을 다시 선택할 수 있도록 초기화
        }
      };
    
       // 드래그 앤 드롭 및 붙여넣기 핸들러
       const handleDrop = (event) => {
        event.preventDefault(); // 브라우저 기본 동작 방지
        
        
        if (!data) {
          alert('이미지를 업로드할 품번/컬러를 선택하세요.');
          return;
        }
        
        const file = event.dataTransfer.files[0];
        if (file && file.type.startsWith('image/')) {
          // 파일이 드롭되면 자동으로 업로드
          handleUpload(file);
        }
      };
    
      const handlePaste = async (event) => {
        
        if (!data) {
          alert('이미지를 업로드할 품번/컬러를 선택하세요.');
          handleDeleteImage();
          return;
        }
        const items = event.clipboardData.items;
        for (let item of items) {
          if (item.type.startsWith('image/')) {
            const file = item.getAsFile();
            if (file) {
              // 파일이 붙여넣기되면 자동으로 업로드
              await handleUpload(file);
            }
          }
        }
      };
    
      // 드래그 이벤트 핸들러 수정
      const handleDragOver = (event) => {
          event.preventDefault();
      };
    
      const handleDragLeave = (event) => {
        event.preventDefault();
      };

      const handleEdit = () => {
        setIsEditMode(true);
        
        if (language === 'ko') {
          // 한국어 모드: 한국어 설명 로드
        setDescription(snowflakeData[0]?.description || '');
          setIncludeTranslation(true); // 번역 옵션 기본 체크
        } else {
          // 영어/중국어 모드: 영어와 중국어 설명 로드
          setDescriptions({
            ko: snowflakeData[0]?.description || '',
            en: snowflakeData[0]?.description_eng || '',
            cn: snowflakeData[0]?.description_cn || ''
          });
          setActiveTab('en'); // 영어 탭부터 시작
          setIncludeTranslation(false); // 번역 옵션 비활성화
        }
        
        // 다음 렌더링 사이클 후에 포커스 설정
        setTimeout(() => {
          if (textareaRef.current) {
            textareaRef.current.focus();
            const len = textareaRef.current.value.length;
            textareaRef.current.setSelectionRange(len, len);
          }
        }, 0);
      }

      const handleCancel = () => {
        setIsEditMode(false);
        setDescription(''); // 한국어 필드 초기화
        setDescriptions({ ko: '', en: '', cn: '' }); // 다국어 필드 초기화
        setActiveTab('en'); // 탭 초기화
        setIncludeTranslation(true); // 체크박스 초기화
        setIsSaving(false);
      }

      // 설명 변경 핸들러 추가
      const handleDescriptionChange = (value) => {
        setDescriptions(prev => ({
          ...prev,
          [activeTab]: value
        }));
      };

            // 번역 함수 (체크박스가 선택된 경우에만 호출)
            const translateDescription = async (text, targetLang) => {
              if (!includeTranslation || language !== 'ko') {
                return snowflakeData[0]?.[targetLang === 'en' ? 'description_eng' : 'description_cn'] || null;
              }
              
              // 한국어 텍스트가 빈 문자열이거나 null이면 빈 문자열 반환
              if (!text || !text.trim()) {
                return '';
              }
              
              try {
                const response = await fetch('/api/translate', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: JSON.stringify({
                    text: text,
                    targetLang: targetLang
                  })
                });
                
                if (response.ok) {
                  const result = await response.json();
                  return result.translatedText;
                } else {
                  console.error('번역 실패');
                  return null;
                }
              } catch (error) {
                console.error('번역 오류:', error);
                return null;
              }
            };
      
            const handleSave = async () => {
              setIsSaving(true);
              
              try {
                let requestBody;
                
                if (language === 'ko') {
                  // 한국어 모드: 한국어 입력 + 선택적 번역
                  let translatedTextEn = null;
                  let translatedTextCn = null;
                  
                  if (includeTranslation) {
                    // 영어와 중국어 번역을 병렬로 수행
                    const [englishTranslation, chineseTranslation] = await Promise.all([
                      translateDescription(description, 'en'),
                      translateDescription(description, 'zh-cn')
                    ]);
                    translatedTextEn = englishTranslation;
                    translatedTextCn = chineseTranslation;
                  } else {
                    translatedTextEn = snowflakeData[0]?.description_eng || null;
                    translatedTextCn = snowflakeData[0]?.description_cn || null;
                  }
                  
                  requestBody = {
                    brd_cd: data.brd_cd,
                    sesn: data.gtm_sesn,
                    part_cd: data.part_cd,
                    description: description,
                    description_eng: translatedTextEn, // 영어 번역 또는 기존값/null
                    description_cn: translatedTextCn   // 중국어 번역 또는 기존값/null
                  };
                } else {
                  // 영어/중국어 모드: 영어와 중국어 직접 입력
                  requestBody = {
                    brd_cd: data.brd_cd,
                    sesn: data.gtm_sesn,
                    part_cd: data.part_cd,
                    description: descriptions.ko || snowflakeData[0]?.description || '', // 기존 한국어 유지
                    description_eng: descriptions.en,
                    description_cn: descriptions.cn
                  };
                }
          
          console.log('저장 데이터:', requestBody);
          
          const response = await fetch('/api/cad-data/save-prdt-description', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(requestBody)
          });
          
          if (response.ok) {
            // 성공시 데이터 다시 불러오기
            const refreshResponse = await fetch('/api/cad-data/get-prdt-description', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({ 
                brd_cd: data.brd_cd, 
                sesn: data.gtm_sesn, 
                part_cd: data.part_cd 
              })
            });
            
            if (refreshResponse.ok) {
              const refreshedData = await refreshResponse.json();
              setSnowflakeData(refreshedData);
            }
            
            setIsEditMode(false);
            setIncludeTranslation(true); // 편집 완료 후 초기화
          } else {
            throw new Error('저장 실패');
          }
        } catch (error) {
          console.error('저장 중 오류 발생:', error);
          alert('저장 중 오류가 발생했습니다.');
        } finally {
          setIsSaving(false);
        }
      }
    
      // 이미지 에러 핸들러 추가
      const handleImageError = () => {
        setImageError(true);
      };

      const handleImageLoad = () => {
        setImageError(false);
      };
    
      // 표시할 텍스트 결정
      const getDisplayText = () => {
        if (!data) {
          return null;
        }
        if (!snowflakeData[0]) {
          return language === 'ko' ? 
            translateText({
              text: '입력/수정 버튼을 클릭하여 설명을 입력하세요.',
              globalLanguage: language,
            }) :
            translateText({
              text: 'No data',
              globalLanguage: language,
            });
        }
        
        if (language === 'ko') {
          return snowflakeData[0].description === '' ? 
            translateText({
              text: '입력/수정 버튼을 클릭하여 설명을 입력하세요.',
              globalLanguage: language,
            }) : 
            snowflakeData[0].description;
        } else {
          // 영어일 때는 description_eng 표시
          return snowflakeData[0].description_eng || 
            snowflakeData[0].description || 
            translateText({
              text: 'No data',
              globalLanguage: language,
            });
        }
      };

      return (
        <FlexBoxVertical 
          style={{justifyContent: 'flex-start'}}
          onClick={(e) => {
            if (e.target === e.currentTarget) {
              setImageEditMode(false);
            }
          }}  
        >
          {/* 파일 입력 필드 (숨김) */}
          <input
            type="file"
            ref={fileInputRef}
            onChange={handleFileChange}
            accept="image/*"
            style={{ display: 'none' }}
          />
    
          {/* 상단부: 코드 및 브랜드 */}
          <FlexBoxHorizontal style={{ height: '40px', margin: '10px 10px 0 10px' }}>
            <Label style={{ width: '45%', margin: '3px' }}>
              <TranslateTypography variant="content2">
                {data && data['part_cd'] ? data['part_cd'] : '품번'}
              </TranslateTypography>
            </Label>
            <Label style={{ width: '45%', margin: '3px' }}>
          {language === 'ko' ? (
            <TranslateTypography variant="content2">
              {data && data['prdt_nm'] ? data['prdt_nm'] : '제품명 '}
            </TranslateTypography>
          ) : (
            <TranslateTypography variant="content2">
              {data && data['prdt_nm_eng'] ? data['prdt_nm_eng'] : 'Product Name'}
            </TranslateTypography>
          )}
        </Label>
          </FlexBoxHorizontal>
  
            {/* 이미지 박스 */}
            <FlexBox
              onDrop={handleDrop}
              onDragOver={(event) => {
                setImageEditMode(true);
                event.preventDefault();
                if (data) {
                  handleDragOver(event); 
                }
              }}
              onPaste={handlePaste}
              onDragLeave={(event) => {
                setImageEditMode(false);
                if (data) {
                  handleDragLeave(event); 
                }
              }}
              tabIndex={0}
              style={{
                width: '80%',
                height: '35%',
                margin: '20px',
                marginBottom: '30px',
                position: 'relative',
                overflow: 'hidden',
                cursor: 'pointer',
              }}
            >
              {data && !imageError && !imageEditMode ? ( // 데이터가 있고 이미지 에러가 없을 때
                <img
                ref={imgRef}
                src={imgSrc}
                alt="Content"
                onError={handleImageError} // 이미지 로드 실패 시 에러 상태 설정
                onLoad={handleImageLoad}   // 이미지 로드 성공 시 에러 상태 해제
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'contain',
                  cursor: 'pointer',
                }}
                onClick={(e) => {
                  setImageEditMode(true);
                }}
              />      
              ) : data ? (
                <ImagePlaceholder>
                  <SimpleButton 
                    onClick={(e) => {
                      fileInputRef.current?.click();
                    }}
                    style={{ width: 'auto', marginBottom: '10px'}}
                  >
                    {translateText({
                      text: '이미지 선택',
                      globalLanguage: language,
                    })}
                  </SimpleButton>
                  <div style={{ alignItems: 'center', gap: '5px', textAlign: 'center', fontSize: '12px', color: '#555' }}>
                    {translateText({text: '이미지를 추가하세요.', globalLanguage: language})}<br /> {translateText({text: '(Ctrl+V, 드래그 & 드롭, 버튼 클릭)', globalLanguage: language})}
                  </div>
                </ImagePlaceholder>
              ) : ( 
                <div style={{width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: '13px', color: 'rgb(119, 119, 119)'}}>{translateText({
                  text: '스타일을 선택하세요',
                  globalLanguage: language,
                })}</div>
              )}
            </FlexBox>
            {/* 텍스트 영역 */}
            <FlexBoxVertical style={{
              width: '90%', 
              height:'50%', 
              display: 'flex', 
              justifyContent: 'center', 
              alignItems: 'center', 
              fontSize: '13px', 
              color: 'rgb(119, 119, 119)'
            }}>
              {isEditMode ? ( 
                // 편집 모드 - 언어별로 다른 입력 방식
                language === 'ko' ? (
                  // 한국어 모드: 한국어만 입력 + 번역 옵션
                  <TextareaContainer>
                    {/* 체크박스를 textarea 상단으로 이동 */}
                    <CheckboxContainer>
                      <input 
                        type="checkbox" 
                        id="includeTranslation"
                        checked={includeTranslation}
                        onChange={(e) => setIncludeTranslation(e.target.checked)}
                        disabled={isSaving}
                        style={{ marginRight: '6px' }}
                      />
                      <label 
                        htmlFor="includeTranslation" 
                        style={{ 
                          fontSize: '11px', 
                          color: isSaving ? '#999' : '#666',
                          cursor: isSaving ? 'not-allowed' : 'pointer',
                          userSelect: 'none'
                        }}
                      >
                        {translateText({
                          text: '영문/중문 번역 자동 저장(번역 시간 소요)',
                          globalLanguage: language,
                        })}
                      </label>
                    </CheckboxContainer>
                    
                    <textarea
                      ref={textareaRef}
                      value={description}
                      onChange={(e) => setDescription(e.target.value)}
                      disabled={isSaving}
                      style={{
                        width: '100%', 
                        height: 'calc(100% - 32px)', // 체크박스 영역을 위한 공간 확보
                        fontSize: '13px', 
                        color: isSaving ? 'rgb(180, 180, 180)' : 'rgb(119, 119, 119)', 
                        border: 'none', 
                        padding: '8px',
                        resize: 'none',
                        outline: 'none',
                        backgroundColor: 'transparent',
                        boxSizing: 'border-box',
                        wordWrap: 'break-word',
                        overflowWrap: 'break-word',
                        whiteSpace: 'pre-wrap',
                        overflow: 'auto',
                        overflowX: 'hidden',
                        overflowY: 'auto'
                      }}
                    />
                  </TextareaContainer>
                ) : (
                  // 영어/중국어 모드: 좌우 분할 입력
                  <div style={{
                    display: 'flex', 
                    width: '90%', 
                    height: '90%',
                    gap: '10px', 
                    overflow: 'hidden'
                  }}>
                    {/* 왼쪽 - 영어 입력 */}
                    <div style={{
                      flex: 1, 
                      display: 'flex',
                      flexDirection: 'column',
                      borderRadius: '6px',
                      border: '1px solid rgb(224, 221, 221)',
                      backgroundColor: '#ffffff',
                      overflow: 'hidden'
                    }}>
                      <HeaderDiv>
                        English
                      </HeaderDiv>
                      <textarea
                        ref={textareaRef}
                        value={descriptions.en}
                        onChange={(e) => setDescriptions(prev => ({ ...prev, en: e.target.value }))}
                        disabled={isSaving}
                        placeholder="Enter English description"
                        style={{
                          width: '100%', 
                          height: '100%',
                          fontSize: '12px', 
                          color: isSaving ? 'rgb(180, 180, 180)' : 'rgb(119, 119, 119)', 
                          border: 'none', 
                          padding: '8px',
                          resize: 'none',
                          outline: 'none',
                          backgroundColor: 'transparent',
                          boxSizing: 'border-box',
                          wordWrap: 'break-word',
                          overflowWrap: 'break-word',
                          whiteSpace: 'pre-wrap',
                          overflow: 'auto'
                        }}
                      />
                    </div>
                    
                    {/* 오른쪽 - 중국어 입력 */}
                    <div style={{
                      flex: 1, 
                      display: 'flex',
                      flexDirection: 'column',
                      borderRadius: '6px',
                      border: '1px solid rgb(224, 221, 221)',
                      backgroundColor: '#ffffff',
                      overflow: 'hidden'
                    }}>
                      <HeaderDiv>
                        中文
                      </HeaderDiv>
                      <textarea
                        value={descriptions.cn}
                        onChange={(e) => setDescriptions(prev => ({ ...prev, cn: e.target.value }))}
                        disabled={isSaving}
                        placeholder="请输入中文说明"
                        style={{
                          width: '100%', 
                          height: '100%',
                          fontSize: '12px', 
                          color: isSaving ? 'rgb(180, 180, 180)' : 'rgb(119, 119, 119)', 
                          border: 'none', 
                          padding: '8px',
                          resize: 'none',
                          outline: 'none',
                          backgroundColor: 'transparent',
                          boxSizing: 'border-box',
                          wordWrap: 'break-word',
                          overflowWrap: 'break-word',
                          whiteSpace: 'pre-wrap',
                          overflow: 'auto'
                        }}
                      />
                    </div>
                  </div>
                )
              ) : (
                // 읽기 모드 - 언어별 조건부 렌더링
                language === 'ko' ? (
                  <ReadOnlyContainer>
                    {getDisplayText()}
                  </ReadOnlyContainer>
                ) : (
                  // 영어일 때는 편집 모드와 동일한 박스 스타일
                  (() => {
                    const hasEngData = snowflakeData[0]?.description_eng;
                    const hasCnData = snowflakeData[0]?.description_cn;
                    
                    // 데이터가 있으면 편집 모드와 동일한 스타일로 표시
                    // 항상 박스를 표시 (No data 조건 제거)
                    return (
                      <div style={{
                        display: 'flex', 
                        width: '90%', 
                        height: '90%',
                        gap: '10px', 
                        overflow: 'hidden'
                      }}>
                        {/* 왼쪽 - 영어 설명 (편집 모드와 동일한 스타일) */}
                        <div style={{
                          flex: 1, 
                          display: 'flex',
                          flexDirection: 'column',
                          borderRadius: '6px',
                          border: '1px solid rgb(224, 221, 221)',
                          backgroundColor: '#ffffff',
                          overflow: 'hidden'
                        }}>
                          <HeaderDiv>
                            English
                          </HeaderDiv>
                          <div style={{
                            width: '100%', 
                            height: '100%',
                            fontSize: '12px', 
                            color: 'rgb(119, 119, 119)',
                            padding: '8px',
                            boxSizing: 'border-box',
                            wordWrap: 'break-word',
                            overflowWrap: 'break-word',
                            whiteSpace: 'pre-wrap',
                            overflow: 'auto',
                            lineHeight: '1.4',
                          }}>
                            {data ? (hasEngData  || 'Click the Input/Edit button to add a description.') : ''}
                          </div>
                        </div>
                        
                        {/* 오른쪽 - 중국어 설명 (편집 모드와 동일한 스타일) */}
                        <div style={{
                          flex: 1, 
                          display: 'flex',
                          flexDirection: 'column',
                          borderRadius: '6px',
                          border: '1px solid rgb(224, 221, 221)',
                          backgroundColor: '#ffffff',
                          overflow: 'hidden'
                        }}>
                          <HeaderDiv>
                            中文
                          </HeaderDiv>
                          <div style={{
                            width: '100%', 
                            height: '100%',
                            fontSize: '12px', 
                            color: 'rgb(119, 119, 119)',
                            padding: '8px',
                            boxSizing: 'border-box',
                            wordWrap: 'break-word',
                            overflowWrap: 'break-word',
                            whiteSpace: 'pre-wrap',
                            overflow: 'auto',
                            lineHeight: '1.4',
                          }}>
                            {data ? (hasCnData  || '点击输入/修改按钮来输入说明。') : ''}
                        </div>
                      </div>
                    </div>
                    );
                  })()
                )
              )}

              {/* 버튼 영역 */}
              <FlexBoxHorizontal style={{width: '100%', height: '100px', display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: '13px', color: 'rgb(119, 119, 119)', gap: '10px'}}>
                {data && (
                  <>
                    {isEditMode ? (
                      <>
                        <SimpleButton 
                          onClick={handleSave}
                          disabled={isSaving}
                          style={{
                            backgroundColor: isSaving ? '#94a3b8' : '#4f46e5',
                            cursor: isSaving ? 'not-allowed' : 'pointer',
                            width: 'auto'
                          }}
                        >
                          {isSaving ? 
                            (includeTranslation ? 
                              translateText({
                                text: '번역 및 저장 중...',
                                globalLanguage: language,
                              }) :
                              translateText({
                                text: '저장 중...',
                                globalLanguage: language,
                              })
                            ) :
                            translateText({
                              text: '저장',
                              globalLanguage: language,
                            })
                          }
                        </SimpleButton>
                        <SimpleButton 
                          onClick={handleCancel}
                          disabled={isSaving}
                          style={{
                            backgroundColor: isSaving ? '#9ca3af' : '#6b7280',
                            cursor: isSaving ? 'not-allowed' : 'pointer',
                            '&:hover': {
                              backgroundColor: isSaving ? '#9ca3af' : '#4b5563 !important'
                            },
                            '&:active': {
                              backgroundColor: isSaving ? '#9ca3af' : '#374151 !important'
                            },
                            width: 'auto'
                          }}
                        >
                          {translateText({
                            text: '취소',
                            globalLanguage: language,
                          })}
                        </SimpleButton>
                      </>
                    ) : (
                      <SimpleButton onClick={handleEdit} style={{width: 'auto'}}>
                        {translateText({
                          text: '입력/수정',
                          globalLanguage: language,
                        })}
                      </SimpleButton>
                    )}
                  </>
                )}
              </FlexBoxHorizontal>
            </FlexBoxVertical>
        </FlexBoxVertical>
      );
    };

    
    // 새로운 styled 컴포넌트 추가 (UploadBox와 ImageContainer 아래에)
    const ImagePlaceholder = styled(FlexBox)`
      width: 100%;
      height: 100%;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      background-color: #fafafa;
    `;
    
    // 깔끔한 통일 버튼 스타일
    const SimpleButton = styled.button`
      padding: ${props => props.small ? '4px 8px' : '8px 16px'};
      background-color: ${props => props.style?.backgroundColor || '#4f46e5'};
      color: white;
      border: none;
      border-radius: 4px;
      font-size: ${props => props.small ? '10px' : '12px'};
      font-weight: 500;
      cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
      transition: background-color 0.2s ease;
      width: ${props => props.small ? '70px' : '140px'};
      opacity: ${props => props.disabled ? 0.8 : 1};
      
      &:hover {
        background-color: ${props => props.disabled ? props.style?.backgroundColor : (props.style?.['&:hover']?.backgroundColor || '#4338ca !important')};
      }
      
      &:active {
        background-color: ${props => props.disabled ? props.style?.backgroundColor : (props.style?.['&:active']?.backgroundColor || '#3730a3')};
      }
    `;

// 새로운 styled 컴포넌트 추가
const TextareaContainer = styled.div`
  width: 90%;
  height: 90%;
  border: 1px solid rgb(224, 221, 221);
  border-radius: 5px;
  background-color: ${props => props.disabled ? '#f8f9fa' : 'white'};
  display: flex;
  flex-direction: column;
  position: relative;
  box-sizing: border-box;
  overflow: hidden;
`;

const ReadOnlyContainer = styled.div`
  width: 90%;
  height: 90%; 
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  font-size: 13px;
  color: rgb(119, 119, 119);
  border: 1px solid rgb(224, 221, 221);
  padding: 8px; 
  text-align: left;
  border-radius: 6px;
  box-sizing: border-box;
  word-wrap: break-word;
  overflow-wrap: break-word;
  white-space: pre-wrap;
  overflow: hidden;
  background-color: #ffffff;
`;

const CheckboxContainer = styled.div`
  padding: 3px 12px;
  border-bottom: 1px solid #e9ecef;
  background-color: #f8f9fa;
  border-radius: 5px 5px 0 0;
  display: flex;
  align-items: center;
  min-height: 32px;
  box-sizing: border-box;
  flex-shrink: 0; /* 체크박스 컨테이너는 크기 고정 */
`;

const HeaderDiv = styled.div`
  font-weight: 600;
  padding: 8px;
  color: #334155;
  font-size: 13px;
  border-bottom: 1px solid rgb(224, 221, 221);
  background-color: #f8f9fa;
  flex-shrink: 0;
  height: 19px !important;
`;
